<template>
  <card class="card-stats" style="min-height: 160px;">
    <div class="row">
      <div class="col-2" v-if="$slots.header">
        <div class="icon-medium text-center">
          <slot name="header"></slot>
        </div>
      </div>
      <div class="col-12" v-if="$slots.content">
        <div class="">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
    <div slot="footer" class="stats" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </card>
</template>
<script>
  import Card from './Card.vue'
  export default {
    name: 'stats-card',
    components: {
      Card
    }
  }

</script>
<style>

</style>
